<template>
  <div class="sidebar">
    <!-- filter -->
    <div class="section filter-box mt-0">
      <div class="row ic-rounded ic-border-padding ic-bg-light-gray">
        <div class="col">
          <div class="title">
            <h3 class="h3">Multimedia</h3>
          </div>
          <div class="side-menu">
            <ul>
              <li class="active"><a href="#">Zdjęcia</a></li>
              <li><a href="#">Wideo</a></li>
              <li><a href="#">Animacje</a></li>
              <li><a href="#">Logotypy</a></li>
            </ul>
          </div>
          <div>
            <small>korzystając z materiałów, prosimy o podpisanie
              ich źródła jako PKP Intercity</small>
          </div>
        </div>
      </div>
    </div>
    <!--    Newsletter-->
    <div class="section newsletter-form d-none d-lg-block">
      <div class="row">
        <div class="col">
          <div class="title">
            <p>Newsletter</p>
            <h3>Bądz na bieżąco</h3>
          </div>
          <p>
            Jeżeli chcesz otrzymywać informacje o planowanych zmianach w rozkładach jazdy, nowych promocjach zapisz się do naszego newslettera.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <form class="g-3 needs-validation ic-form" novalidate>
            <div class="input-group mb-3 icon icon__envelope">
              <input type="email" class="form-control" id="" placeholder="Adres e-mail">
            </div>
            <div class="m-1 mt-3">
                <div class="form-check mt-3">
                  <input class="form-check-input" type="checkbox" value="" id="invalidCheck" required>
                  <label class="form-check-label font-size-xs" for="invalidCheck">
                    Wyrażam zgodę na przetwarzanie moich danych osobowych, zgodnie z Rozp. Parlamentu Europejskiego i Rady (UE) 2016/679.
                    kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE.
                  </label>
                </div>
                <button type="submit" class="btn btn-info mt-3">Zapisz się</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'section-sidebar-pr',
  components: {
  },
  data() {
    return {}
  }
}
</script>